export default {
  label: {
    fontSize: 16,
  },
}
